import { render } from "./PackageInfo.vue?vue&type=template&id=e00375ec&scoped=true"
import script from "./PackageInfo.vue?vue&type=script&lang=ts"
export * from "./PackageInfo.vue?vue&type=script&lang=ts"

import "./PackageInfo.vue?vue&type=style&index=0&id=e00375ec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-e00375ec"

export default script